import React, { useEffect } from 'react'


const useTitle = (title) => {
  useEffect(() => {
    document.title = `${title} | Aprender IA`;
  }, []);
};

export default useTitle;
